/**
 * Tour Registry — central lookup for all guided tours.
 * To add a new tour, import its config and add it to the map.
 */
import { activationTour } from "./tours/activationTour";

export const tourRegistry = {
  [activationTour.id]: activationTour,
};
